import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionLabel, SerifHeading } from "@/components/site/primitives";
import { SITE, EDUCATION, CERTIFICATIONS } from "@/lib/site-data";

export default function AboutPage() {
  return (
    <div data-testid="page-about" className="pt-32 md:pt-40 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5">
            <SectionLabel>About</SectionLabel>
            <SerifHeading className="mt-6">
              Advocate Samikshaa K
            </SerifHeading>
            <div className="mt-4 eyebrow text-[#B8912C]">
              Real Estate Lawyer · Bengaluru
            </div>
            <Reveal className="mt-10">
              <div className="relative">
                <img
                  src={SITE.images.portrait}
                  alt="Portrait of Advocate Samikshaa K"
                  data-testid="about-portrait"
                  className="w-full h-[520px] object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute -bottom-4 -right-4 w-24 h-24 border border-gold hidden md:block" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pl-8">
            <Reveal>
              <p className="text-lg md:text-xl text-navy leading-relaxed font-serif">
                Advocate Samikshaa K is a qualified lawyer with over six years of
                experience in real estate law, contract drafting, legal advisory,
                litigation support, and regulatory compliance.
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <p className="mt-6 text-muted-foreground leading-relaxed">
                She currently serves as the In-House Real Estate Lawyer at Sri
                Sumeru Realty Pvt. Ltd., where she manages land due diligence,
                registration documentation, contract drafting, legal compliance,
                and court matters.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-5 text-muted-foreground leading-relaxed">
                Throughout her career, she has advised organizations in the real
                estate, technology, nonprofit, and corporate sectors — combining
                strong technical knowledge with practical business understanding
                so clients can navigate complex legal matters confidently.
              </p>
            </Reveal>

            {/* EDUCATION */}
            <div className="mt-16">
              <SectionLabel>Education</SectionLabel>
              <div className="mt-8 divide-y divide-border border-t border-b border-border">
                {EDUCATION.map((e, idx) => (
                  <Reveal key={e.degree} delay={idx * 0.05}>
                    <div
                      data-testid={`edu-${idx}`}
                      className="py-6 md:py-8 grid grid-cols-1 md:grid-cols-12 gap-4 items-start"
                    >
                      <div className="md:col-span-3 eyebrow text-[#B8912C]">
                        {e.period}
                      </div>
                      <div className="md:col-span-9">
                        <div className="font-serif text-2xl text-navy leading-tight">
                          {e.degree}
                        </div>
                        <div className="text-sm text-muted-foreground mt-2">
                          {e.school}
                        </div>
                        {e.stream && (
                          <div className="text-xs uppercase tracking-[0.22em] text-navy/70 mt-3">
                            {e.stream}
                          </div>
                        )}
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>

            {/* CERTIFICATIONS */}
            <div className="mt-14">
              <SectionLabel>Certifications</SectionLabel>
              <ul className="mt-6 flex flex-wrap gap-3">
                {CERTIFICATIONS.map((c, idx) => (
                  <li
                    key={c}
                    data-testid={`cert-${idx}`}
                    className="border border-border px-4 py-2 text-sm text-navy bg-white"
                  >
                    {c}
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-14">
              <Link
                to="/contact"
                data-testid="about-cta-consult"
                className="inline-flex items-center gap-3 bg-navy text-white px-6 py-3 text-xs uppercase tracking-[0.24em] font-semibold hover:bg-[#132644] transition-colors"
              >
                Book a Consultation
                <ArrowRight size={14} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
